import { authenticated_api } from "./base";

/**
 * Home dashboard feeds (FE #700, BE /home/*). Each call returns the axios
 * response, or the error's response, like the other API adapters.
 */

/** GET /home/enrichments — needs_attention, recent_completed, completed_total. */
export const getHomeEnrichmentsApi = async () => {
  try {
    return await authenticated_api.get("/home/enrichments");
  } catch (error) {
    return error.response;
  }
};

/** POST /home/enrichments/{id}/reviewed — clears Needs Attention (G8). Never re-runs. */
export const markHomeEnrichmentReviewedApi = async (batchId) => {
  try {
    return await authenticated_api.post(`/home/enrichments/${encodeURIComponent(batchId)}/reviewed`);
  } catch (error) {
    return error.response;
  }
};

/** GET /home/saved-search-updates — recent Saved Searches with unseen counts (R8). */
export const getSavedSearchUpdatesApi = async () => {
  try {
    return await authenticated_api.get("/home/saved-search-updates");
  } catch (error) {
    return error.response;
  }
};

/** GET /home/saved-search-updates/{id}/new-company-ids — the +N focus ids. */
export const getSavedSearchNewCompanyIdsApi = async (savedSearchId) => {
  try {
    return await authenticated_api.get(
      `/home/saved-search-updates/${encodeURIComponent(savedSearchId)}/new-company-ids`,
    );
  } catch (error) {
    return error.response;
  }
};

/**
 * POST /saved-searches/{id}/visit. `ended: true` marks the search seen (Spec §7).
 * `keepalive` lets the end-of-visit write survive a tab close or reload; auth is
 * the session cookie, so a plain fetch with credentials carries it.
 */
export const recordSavedSearchVisitApi = (savedSearchId, { ended = false, keepalive = false } = {}) => {
  const path = `/saved-searches/${encodeURIComponent(savedSearchId)}/visit`;
  if (keepalive && typeof fetch === "function") {
    return fetch(`${authenticated_api.defaults.baseURL || ""}${path}`, {
      method: "POST",
      credentials: "include",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ended }),
    }).catch(() => undefined);
  }
  return authenticated_api.post(path, { ended }).catch((error) => error.response);
};

/** GET/PATCH /home/preferences — last opened search and getting-started dismissal (G9). */
export const getHomePreferencesApi = async () => {
  try {
    return await authenticated_api.get("/home/preferences");
  } catch (error) {
    return error.response;
  }
};

export const updateHomePreferencesApi = async (preferences) => {
  try {
    return await authenticated_api.patch("/home/preferences", preferences);
  } catch (error) {
    return error.response;
  }
};
